const emergencyPk = {
	buttons: {
		gas: 'گیس سلنڈر',
		medicine: 'ایمرجنسی دوا',
	},
	common: {
		nameLabel: 'آپ کا نام',
		phoneLabel: 'موبائل نمبر',
		villageLabel: 'گاؤں/علاقہ',
		houseNumberLabel: 'گھر نمبر',
		detailsLabel: 'اضافی معلومات',
		detailsPlaceholder: 'اگر کوئی خصوصی ہدایات ہوں',
		districtLabel: 'ضلع',
		upazillaLabel: 'تحصیل',
		cancel: 'منسوخ کریں',
	},
	gas: {
		title: 'گیس سلنڈر ریفل',
		companyLabel: 'گیس کمپنی',
		cylinderSizeLabel: 'سلنڈر سائز',
		cylinderSizePlaceholder: 'سلنڈر سائز منتخب کریں',
		quantityLabel: 'تعداد',
		companies: {
			bashundhara: 'Bashundhara Gas',
			jamuna: 'Jamuna Gas',
			omera: 'Omera Gas',
			beximco: 'Beximco Gas',
			fresh: 'Fresh Gas',
			totalgaz: 'Totalgaz',
			others: 'دیگر',
		},
		cylinderSizeOptions: {
			"12kg": '12 کلو',
			"33kg": '33 کلو',
			"45kg": '45 کلو',
		},
		price: {
			header: 'قیمت کی تفصیل',
			unitPrice: 'فی یونٹ قیمت',
			subtotal: 'ذیلی مجموعہ',
			delivery: 'ڈلیوری چارج',
			total: 'کل رقم',
			note: '* کیش آن ڈلیوری دستیاب ہے',
			unitSuffix: 'عدد',
		},
		orderNow: 'آرڈر کریں',
	},
	medicine: {
		title: 'ایمرجنسی میڈیسن سروس',
		medicineNameLabel: 'دوائی کا نام',
		medicineNamePlaceholder: 'کون سی دوائی چاہیے؟',
		urgencyLabel: 'ہنگامی سطح',
		urgencyOptions: {
			normal: 'عام',
			urgent: 'فوری',
			emergency: 'ہنگامی',
		},
		prescriptionLabel: 'نسخہ (اگر ہو)',
		prescriptionPlaceholder: 'ڈاکٹر کا نسخہ یا دوائی کی تفصیل',
		uploadNote: 'نسخہ اپلوڈ اختیاری ہے؛ آپ تصویر یا PDF اپلوڈ کر سکتے ہیں۔',
		uploadButton: 'نسخہ اپلوڈ کریں (اختیاری)',
		selectedFilePrefix: 'منتخب فائل:',
		submit: 'ایمرجنسی آرڈر کریں',
	}
};

export default emergencyPk;


